import { combineReducers, configureStore } from '@reduxjs/toolkit'

import { configureApiStore } from '../../common/api/api'
import communicationStore from '../domains/communication/models/communication.store'
import { emailSenderReducer } from '../domains/communication/store'
import deactivationCaseStore from '../domains/deactivationCase/models/deactivationCase.store'
import googlePlacesReducer from '../domains/googlePlaces/store/googlePlacesSlice'
import accountStore from '../domains/person/store/account/assignAccount.store'
import leadStore from '../domains/person/store/leads/assignLead.store'
import { personDetailFormReducer } from '../domains/person/store/personDetailForm'
import searchStore from '../domains/person/store/search/assignSearch.store'
import roleStore from '../domains/role/models/role.store'
import runProcessStore from '../domains/run-process/models/RunProcess.store'
import smsCampaignStore from '../domains/smsCampaigns/models/smsCampaign.store'
import { rootApi } from './api/rootApi'
import routerMiddleware from './middleware/router.middleware'

import authStore from '@v2/domains/auth/store/auth.store'
import organizationSwitchStore from '@v2/domains/organization/store/organizationSwitch.store'
import uiStore from '@v2/domains/ui/store/ui.store'
import userStore from '@v2/domains/user/store/user.store'
import usersStore from '@v2/domains/user/store/users.store'

const reducers = {
  auth: authStore,
  organizationSwitch: organizationSwitchStore,
  user: userStore,
  ui: uiStore,
  communication: communicationStore,
  emailSender: emailSenderReducer,
  deactivationCase: deactivationCaseStore,
  lead: leadStore,
  search: searchStore,
  account: accountStore,
  runProcess: runProcessStore,
  smsCampaign: smsCampaignStore,
  role: roleStore,
  users: usersStore,
  googlePlaces: googlePlacesReducer,
  personDetailForm: personDetailFormReducer,
}

const rootReducer = combineReducers({
  ...reducers,
  [rootApi.reducerPath]: rootApi.reducer,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(routerMiddleware)
      .concat(rootApi.middleware),
})

configureApiStore(store)

export type RootState = ReturnType<typeof rootReducer> & {
  getState: () => RootState
}
export type AppDispatch = typeof store.dispatch
